import { render, staticRenderFns } from "./FileCollectInfoDialog.vue?vue&type=template&id=c401d618&scoped=true&"
import script from "./FileCollectInfoDialog.vue?vue&type=script&lang=ts&"
export * from "./FileCollectInfoDialog.vue?vue&type=script&lang=ts&"
import style0 from "./FileCollectInfoDialog.vue?vue&type=style&index=0&id=c401d618&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c401d618",
  null
  
)

export default component.exports